var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-button',{directives:[{name:"indexed",rawName:"v-indexed"}],attrs:{"type":"primary","icon":_vm.icon,"loading":_vm.loading},on:{"click":_vm.save}},[_c('span',{staticClass:"hidden-sm-and-down"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }